export default {
      id: "ic_virtual_horse_race-usage",
      viewBox: "0 0 27 28",
      url: "/" + "images/icons.3.109.2.svg#ic_virtual_horse_race-usage",
      toString: function () {
        return this.url;
      }
    }